import React from "react";
import { SummaryContainer, HighlightText } from "./styles";
import { ReactComponent as DocsIcon } from "../../../../../../assets/kinologyIcons/svg/docs_dash.svg";
import { ReactComponent as MonitoringIcon } from "../../../../../../assets/kinologyIcons/svg/monitoring.svg";
import { ReactComponent as WarningIcon } from "../../../../../../assets/kinologyIcons/svg/warning_dash.svg";

interface CopilotSummaryProps {
	summaryText: string;
	isV1Mode: boolean;
	activeTab?: "resumo" | "evolucao" | "atencao";
	summaryTitle?: string;
	isLoading?: boolean;
	error?: string | null;
	isEmpty?: boolean;
	onRetry?: () => void;
}

const CopilotSummary: React.FC<CopilotSummaryProps> = ({
	summaryText,
	isV1Mode,
	activeTab,
	summaryTitle,
	isLoading = false,
	error,
	isEmpty = false,
	onRetry,
}) => {
	const prefix = summaryTitle
		? summaryTitle.endsWith(":")
			? summaryTitle
			: summaryTitle + ":"
		: isV1Mode
		? "Alterações Significativas:"
		: activeTab === "resumo"
		? "Resumo do Paciente:"
		: activeTab === "evolucao"
		? "Evolução:"
		: "Pontos de atenção:";

	const Icon = isV1Mode
		? DocsIcon
		: activeTab === "resumo"
		? DocsIcon
		: activeTab === "evolucao"
		? MonitoringIcon
		: WarningIcon;

	return (
		<SummaryContainer
			style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}
			aria-busy={isLoading}
		>
			<Icon
				width="14px"
				height="14px"
				fill="#ffffff"
				style={{ marginTop: "2px", flexShrink: 0 }}
			/>
			{isLoading ? (
				<div style={{ width: "100%" }}>
					<div className="summary-skeleton" />
					<div className="summary-skeleton short" />
				</div>
			) : error ? (
				<div role="alert">
					{error}{" "}
					{onRetry && (
						<button type="button" onClick={onRetry}>
							Tentar novamente
						</button>
					)}
				</div>
			) : isEmpty ? (
				<div>Nenhum conteúdo clínico disponível para este paciente.</div>
			) : (
				<div>
					<HighlightText>{prefix}</HighlightText>
					{summaryText}
				</div>
			)}
		</SummaryContainer>
	);
};

export default CopilotSummary;
